export const setLoggingOut = (isLoggingOut) => {
    return {
      type: 'SET_LOGGING_OUT',
      payload: isLoggingOut,
    };
  };